import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

let socket = null;
let visibilityHandlerAttached = false;

export function getStoredToken() {
	const raw = localStorage.getItem("token");
	if (!raw) {
		return null;
	}

	try {
		const parsed = JSON.parse(raw);
		return typeof parsed === "string" && parsed.length > 0 ? parsed : null;
	} catch {
		return raw.length > 0 ? raw : null;
	}
}

function attachVisibilityHandler(activeSocket) {
	if (visibilityHandlerAttached || typeof document === "undefined") {
		return;
	}

	visibilityHandlerAttached = true;
	document.addEventListener("visibilitychange", () => {
		if (
			document.visibilityState === "visible" &&
			activeSocket &&
			!activeSocket.connected
		) {
			activeSocket.connect();
		}
	});
}

function createSocket() {
	const backendUrl = getBackendUrl();
	const token = getStoredToken();

	const options = {
		transports: ["websocket", "polling"],
		reconnection: true,
		reconnectionAttempts: Infinity,
		reconnectionDelay: 1000,
		reconnectionDelayMax: 5000,
		timeout: 20000,
	};

	if (token) {
		options.query = { token };
	}

	const instance = openSocket(backendUrl, options);
	attachVisibilityHandler(instance);
	return instance;
}

function connectToSocket() {
	if (!getStoredToken()) {
		return null;
	}

	if (!socket) {
		socket = createSocket();
	} else if (!socket.connected) {
		socket.connect();
	}

	return socket;
}

export function disconnectSocket() {
	if (socket) {
		socket.removeAllListeners();
		socket.disconnect();
		socket = null;
	}
	visibilityHandlerAttached = false;
}

export default connectToSocket;
